export interface UserProjectPermissions {
  isAdmin: boolean;
  projectRoles: ProjectUserRole[];
  accessToTools: string[];
}

export enum ProjectUserRole {
  TeamMember = "TeamMember",
  ProductOwner = "ProductOwner",
  StakeHolder = "StakeHolder",
  ScrumMaster = "ScrumMaster",
}
